import { BrowserRouter, Routes, Route } from 'react-router-dom';
import RTOCreator from './RTO/RTOCreator';
import RTOUser from './RTOUser/RTOUser';
import { faHistory } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RTOHistory from './RTOHistory/RTOHistory';
import { useNavigate } from 'react-router-dom';

// Create a layout component that includes the header and children
function Layout({ children }) {
  const navigate = useNavigate();
  return (
    <>
      {/* Fixed Header */}
      <header className="sticky-top py-1 p-0 bg-primary m0" style={{
        background: 'linear-gradient(145deg, #1a2980, #26d0ce)',
        textShadow: '0 1px 3px rgba(0,0,0,0.4)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        borderBottom: '1px solid rgba(255,255,255,0.1)'
      }}>
        <div className="d-flex justify-content-center align-items-center">
          <h1 className="text-white mb-0 px-4 py-2 rounded-3 d-flex align-items-center">
            Vehicle Fancy Number Management
            <FontAwesomeIcon 
              icon={faHistory} 
              className="ms-5" 
              style={{ fontSize: '1.2rem', cursor: 'pointer', marginLeft: '90px' }}
              title="History"
              onClick={() => navigate('/RTOHistory')}
            />
          </h1>
        </div>
      </header>
      
      {/* Page content */}
      <main>
        {children}
      </main>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={
          <Layout>
            <RTOCreator />
          </Layout>
        } />
        <Route path="/rto/:rtoNumber" element={
          <Layout>
            <RTOUser />
          </Layout>
        } />
        <Route path="/RTOHistory" element={
          <Layout>
            <RTOHistory />
          </Layout>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;